import React, { Component } from "react";

class Footer extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var networks = this.props.sharedBasicInfo.social.map(function (network) {
        return (
          <span key={network.name} className="m-4 footer-social-link">
            <a href={network.url} target="_blank" rel="noopener noreferrer">
              <i className={network.class}></i>
            </a>
          </span>
        );
      });
      var emailLink = this.props.sharedBasicInfo.email
        ? (
          <span key="email" className="m-4 footer-social-link">
            <a href={`mailto:${this.props.sharedBasicInfo.email}`}>
              <i className="fas fa-envelope"></i>
            </a>
          </span>
        )
        : null;
    }

    return (
      <footer>
        <div className="col-md-12">
          <div className="social-links">{networks}{emailLink}</div>

          <div className="copyright py-4 text-center">
            <div className="container">
              <small>
                Copyright &copy;{" "}
                {this.props.sharedBasicInfo
                  ? this.props.sharedBasicInfo.name
                  : "???"}
              </small>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
